import axios from 'axios'

import type { ReleaseHistory } from '../../shared/types/collection'
import { invalidateCollectionState } from '../stores/collectionStore'
import { getSessionSignal } from './requestSession'

/**
 * Adds one listen entry for a release.
 */
export async function addListen(
	releaseId: number,
	date: Date | null,
	hideDurationMonths: number | null,
	unknownDate = false,
): Promise<void> {
	const signal = getSessionSignal()
	await axios.post('/api/history/listen', {
		date,
		hideDurationMonths,
		releaseId,
		unknownDate,
	})
	signal.throwIfAborted()
	// The write is committed even if the subsequent history read fails.
	invalidateCollectionState()
}

/**
 * Replaces the stored listen history and hidden-state metadata for a release.
 */
export async function updateHistory(
	releaseId: number,
	historyDates: (string | Date)[],
	hideDurationMonths: number | null,
	unknownDateCount: number,
): Promise<ReleaseHistory> {
	const signal = getSessionSignal()
	const res = await axios.post('/api/history/edit', {
		releaseId,
		historyDates,
		hideDurationMonths,
		unknownDateCount,
	})
	signal.throwIfAborted()
	invalidateCollectionState()
	return res.data as ReleaseHistory
}

/**
 * Fetches the stored history document for a release.
 */
export async function getHistoryById(
	releaseId: number,
): Promise<ReleaseHistory> {
	const res = await axios.get(`/api/history/${releaseId}`)
	return res.data as ReleaseHistory
}
